// import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import API from './api';

// function App() {
//   // Navigation / View Switcher State ('single' | 'bulk')
//   const [activeTab, setActiveTab] = useState('single');

//   // Shared Identity / Persona Switcher State
//   const [activeUser, setActiveUser] = useState('officer1');

//   // -------------------------------------------------------------
//   // STATE: SINGLE CERTIFICATE WORKFLOW
//   // -------------------------------------------------------------
//   const [studentName, setStudentName] = useState('');
//   const [certId, setCertId] = useState('');
//   const [docType, setDocType] = useState('SSLC');
//   const [file, setFile] = useState(null);

//   const [statusMsg, setStatusMsg] = useState({ text: '', isError: false });
//   const [result, setResult] = useState(null);
//   const [latencyData, setLatencyData] = useState(null);
//   const [historyTrail, setHistoryTrail] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [historyLoading, setHistoryLoading] = useState(false);
//   const [revokeLoading, setRevokeLoading] = useState(false);

//   // -------------------------------------------------------------
//   // STATE: BULK ASYNC REDIS/BULLMQ WORKFLOW
//   // -------------------------------------------------------------
//   const [zipFile, setZipFile] = useState(null);
//   const [bulkLoading, setBulkLoading] = useState(false);
//   const [jobId, setJobId] = useState(null);
//   const [jobState, setJobState] = useState(''); // 'WAITING' | 'ACTIVE' | 'COMPLETED' | 'FAILED'
//   const [jobProgress, setJobProgress] = useState(0);
//   const [bulkResult, setBulkResult] = useState(null);
//   const [bulkError, setBulkError] = useState(null);

//   const pollIntervalRef = useRef(null);

//   const showStatus = (text, isError = false) => {
//     setStatusMsg({ text, isError });
//   };

//   const validateInputs = () => {
//     if (!file) {
//       showStatus('Please select a certificate PDF file', true);
//       return false;
//     }
//     if (!studentName.trim() || !certId.trim()) {
//       showStatus('Please enter Student Name and Certificate ID', true);
//       return false;
//     }
//     return true;
//   };

//   const createFormData = () => {
//     const formData = new FormData();
//     formData.append('pdf', file);
//     formData.append('studentName', studentName.trim());
//     formData.append('certId', certId.trim());
//     formData.append('docType', docType.trim());
//     return formData;
//   };

//   // 1. Issue Handler (Single)
//   const handleIssue = async (e) => {
//     e.preventDefault();
//     if (!validateInputs()) return;

//     setLoading(true);
//     setResult(null);
//     setLatencyData(null);
//     setHistoryTrail(null);

//     try {
//       const formData = createFormData();
//       const res = await API.post('http://localhost:5000/api/certificates/issue-pdf-text', formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//           'x-user-identity': activeUser
//         }
//       });
//       showStatus(`Certificate registered! Textual Hash: ${res.data.certHash.substring(0, 16)}...`, false);
//       setLatencyData(res.data.latency);
//       setResult({
//         certHash: res.data.certHash,
//         certificate: {
//           certId: res.data.certId,
//           docType: docType.trim(),
//           issuer: `Pareeksha Bhavan (${activeUser})`,
//           issuedAt: new Date().toISOString(),
//           isRevoked: false
//         }
//       });
//     } catch (err) {
//       showStatus(err.response?.data?.error || err.message, true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // 2. Verify Handler (Single)
//   const handleVerify = async (e) => {
//     e.preventDefault();
//     if (!validateInputs()) return;

//     setLoading(true);
//     setResult(null);
//     setLatencyData(null);
//     setHistoryTrail(null);

//     try {
//       const formData = createFormData();
//       const res = await API.post('http://localhost:5000/api/certificates/verify-pdf-text', formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//           'x-user-identity': activeUser
//         }
//       });
//       setResult(res.data);
//       setLatencyData(res.data.latency);
//       showStatus(
//         res.data.isRevoked
//           ? 'Certificate record found, but it has been REVOKED.'
//           : 'Document verified: Content and visuals matched on Fabric ledger!',
//         res.data.isRevoked
//       );
//     } catch (err) {
//       showStatus(err.response?.data?.error || 'Verification failed: Content altered or record not found.', true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // 3. History Handler
//   const handleFetchHistory = async () => {
//     if (!result?.certHash) return;

//     setHistoryLoading(true);
//     try {
//       const res = await API.get(`http://localhost:5000/api/certificates/history/${result.certHash}`, {
//         headers: { 'x-user-identity': activeUser }
//       });
//       setHistoryTrail(res.data.history || []);
//       showStatus(`Retrieved ${res.data.auditTrailLength || res.data.history?.length || 0} point-in-time lifecycle record(s).`, false);
//     } catch (err) {
//       showStatus(err.response?.data?.error || 'Failed to retrieve history audit log.', true);
//     } finally {
//       setHistoryLoading(false);
//     }
//   };

//   // 4. Revoke Handler
//   const handleRevoke = async () => {
//     if (!result?.certHash) return;

//     const reason = window.prompt('Enter reason for revoking this certificate:', 'Document invalidated by authority');
//     if (!reason) return;

//     setRevokeLoading(true);
//     try {
//       const res = await API.post('http://localhost:5000/api/certificates/revoke', {
//         certHash: result.certHash,
//         reason
//       }, {
//         headers: {
//           'x-user-identity': activeUser
//         }
//       });

//       showStatus(`Revocation successful: ${res.data.message}`, true);

//       setResult(prev => ({
//         ...prev,
//         isRevoked: true,
//         certificate: {
//           ...prev?.certificate,
//           isRevoked: true,
//           revokeReason: reason
//         }
//       }));

//       if (historyTrail) {
//         handleFetchHistory();
//       }
//     } catch (err) {
//       showStatus(err.response?.data?.error || 'Failed to revoke certificate.', true);
//     } finally {
//       setRevokeLoading(false);
//     }
//   };

//   // -------------------------------------------------------------
//   // HANDLERS: ASYNC BULK ZIP INGESTION (REDIS + BULLMQ POLLING)
//   // -------------------------------------------------------------

//   // Cleanup polling interval on unmount
//   useEffect(() => {
//     return () => {
//       if (pollIntervalRef.current) clearInterval(pollIntervalRef.current);
//     };
//   }, []);

//   const startJobPolling = (targetJobId) => {
//     if (pollIntervalRef.current) clearInterval(pollIntervalRef.current);

//     pollIntervalRef.current = setInterval(async () => {
//       try {
//         const res = await API.get(`http://localhost:5000/api/certificates/batch-status/${targetJobId}`);
//         const { status, progress, result, error } = res.data;

//         setJobState(status);
//         setJobProgress(progress || 0);

//         if (status === 'COMPLETED') {
//           clearInterval(pollIntervalRef.current);
//           setBulkLoading(false);
//           setBulkResult(result);
//         } else if (status === 'FAILED') {
//           clearInterval(pollIntervalRef.current);
//           setBulkLoading(false);
//           setBulkError(error || 'Background worker encountered a fatal error processing batch.');
//         }
//       } catch (err) {
//         clearInterval(pollIntervalRef.current);
//         setBulkLoading(false);
//         setBulkError(err.response?.data?.error || 'Lost connection while tracking batch status.');
//       }
//     }, 1500); // Poll every 1.5 seconds
//   };

//   const handleBulkUpload = async (e) => {
//     e.preventDefault();
//     if (!zipFile) {
//       setBulkError('Please select a .zip archive containing manifest.json and PDFs.');
//       return;
//     }

//     const formData = new FormData();
//     formData.append('zipFile', zipFile);

//     setBulkLoading(true);
//     setBulkError(null);
//     setBulkResult(null);
//     setJobId(null);
//     setJobProgress(0);
//     setJobState('UPLOADING');

//     try {
//       // 1. Submit to the async Redis queue endpoint
//       const res = await API.post('http://localhost:5000/api/certificates/queue-zip-batch', formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//           'x-user-identity': activeUser
//         }
//       });

//       const newJobId = res.data.jobId;
//       setJobId(newJobId);
//       setJobState('QUEUED');

//       // 2. Start polling for real-time extraction & commit progress
//       startJobPolling(newJobId);
//     } catch (err) {
//       setBulkLoading(false);
//       setBulkError(err.response?.data?.error || 'Failed to submit batch to queue.');
//     }
//   };

//   const handleInspectBatchHash = async (certHash) => {
//     setActiveTab('single');
//     showStatus(`Inspecting batch-committed hash: ${certHash.substring(0, 16)}...`, false);
//     setLoading(true);
//     setResult(null);
//     setLatencyData(null);
//     setHistoryTrail(null);

//     try {
//       const res = await API.get(`http://localhost:5000/api/certificates/verify/${certHash}`, {
//         headers: { 'x-user-identity': activeUser }
//       });
//       setResult(res.data);
//     } catch (err) {
//       showStatus(err.response?.data?.error || 'Failed to resolve hash from ledger.', true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div style={{ padding: '2rem', fontFamily: 'Segoe UI, sans-serif', maxWidth: '880px', margin: 'auto' }}>

//       {/* 1. Persona / Workstation Switcher Header */}
//       <div style={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         background: '#e9ecef',
//         padding: '10px 16px',
//         borderRadius: '6px',
//         marginBottom: '1.2rem',
//         border: '1px solid #ced4da'
//       }}>
//         <div>
//           <strong>Active Workstation Session: </strong>
//           <span style={{ color: activeUser === 'officer1' ? '#0056b3' : '#6f42c1', fontWeight: 'bold' }}>
//             {activeUser === 'officer1' ? 'Officer 1 (Authorized Issuer)' : 'Officer 2 (Joint Controller / Audit)'}
//           </span>
//         </div>
//         <select
//           value={activeUser}
//           onChange={e => setActiveUser(e.target.value)}
//           style={{ padding: '6px 12px', borderRadius: '4px', border: '1px solid #adb5bd', fontWeight: 'bold' }}
//         >
//           <option value="officer1">Switch to Officer 1 (Authorized Issuer)</option>
//           <option value="officer2">Switch to Officer 2 (Audit / Controller)</option>
//         </select>
//       </div>

//       <h1 style={{ borderBottom: '2px solid #0056b3', paddingBottom: '0.5rem', color: '#0056b3', margin: 0 }}>
//         Fabric PDF Content Verification System
//       </h1>
//       <p style={{ color: '#555', fontSize: '0.95rem', marginTop: '6px', marginBottom: '1.5rem' }}>
//         Enterprise credential anchoring using RFC 8785 canonical dual-layer hashing over Hyperledger Fabric 2.5.
//       </p>

//       {/* 2. Navigation Tabs */}
//       <div style={{ display: 'flex', gap: '8px', marginBottom: '1.5rem', borderBottom: '1px solid #dee2e6' }}>
//         <button
//           type="button"
//           onClick={() => setActiveTab('single')}
//           style={{
//             padding: '10px 20px',
//             border: 'none',
//             borderBottom: activeTab === 'single' ? '3px solid #0056b3' : '3px solid transparent',
//             background: activeTab === 'single' ? '#f8f9fa' : 'transparent',
//             color: activeTab === 'single' ? '#0056b3' : '#6c757d',
//             fontWeight: 'bold',
//             cursor: 'pointer',
//             fontSize: '1rem',
//             borderRadius: '4px 4px 0 0'
//           }}
//         >
//           📄 Single Certificate Lifecycle
//         </button>

//         <button
//           type="button"
//           onClick={() => setActiveTab('bulk')}
//           style={{
//             padding: '10px 20px',
//             border: 'none',
//             borderBottom: activeTab === 'bulk' ? '3px solid #0056b3' : '3px solid transparent',
//             background: activeTab === 'bulk' ? '#f8f9fa' : 'transparent',
//             color: activeTab === 'bulk' ? '#0056b3' : '#6c757d',
//             fontWeight: 'bold',
//             cursor: 'pointer',
//             fontSize: '1rem',
//             borderRadius: '4px 4px 0 0'
//           }}
//         >
//           📦 Asynchronous Bulk Ingestion (Redis / BullMQ)
//         </button>
//       </div>

//       {/* ============================================================= */}
//       {/* VIEW 1: SINGLE CERTIFICATE WORKFLOW                           */}
//       {/* ============================================================= */}
//       {activeTab === 'single' && (
//         <div>
//           {statusMsg.text && (
//             <div style={{
//               padding: '12px',
//               borderRadius: '4px',
//               marginBottom: '1.5rem',
//               backgroundColor: statusMsg.isError ? '#f8d7da' : '#d4edda',
//               color: statusMsg.isError ? '#721c24' : '#155724',
//               border: `1px solid ${statusMsg.isError ? '#f5c6cb' : '#c3e6cb'}`
//             }}>
//               {statusMsg.text}
//             </div>
//           )}

//           <div style={{ border: '1px solid #ddd', borderRadius: '8px', padding: '1.5rem', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
//             <form style={{ display: 'grid', gap: '14px' }}>
//               <div>
//                 <label><strong>Upload Certificate PDF:</strong></label>
//                 <input
//                   type="file"
//                   accept="application/pdf"
//                   onChange={e => setFile(e.target.files[0])}
//                   style={{ display: 'block', marginTop: '6px' }}
//                   required
//                 />
//               </div>

//               <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
//                 <div>
//                   <label><strong>Student Name:</strong></label>
//                   <input
//                     type="text"
//                     placeholder="e.g. AKARSH PRAVEEN"
//                     value={studentName}
//                     onChange={e => setStudentName(e.target.value)}
//                     style={{ width: '100%', padding: '8px', marginTop: '4px', boxSizing: 'border-box' }}
//                     required
//                   />
//                 </div>
//                 <div>
//                   <label><strong>Certificate / Register ID:</strong></label>
//                   <input
//                     type="text"
//                     placeholder="e.g. REG-2026-8890"
//                     value={certId}
//                     onChange={e => setCertId(e.target.value)}
//                     style={{ width: '100%', padding: '8px', marginTop: '4px', boxSizing: 'border-box' }}
//                     required
//                   />
//                 </div>
//               </div>

//               <div>
//                 <label><strong>Document / Exam Type:</strong></label>
//                 <input
//                   type="text"
//                   placeholder="e.g. SSLC, KTET, DEGREE"
//                   value={docType}
//                   onChange={e => setDocType(e.target.value)}
//                   style={{ width: '100%', padding: '8px', marginTop: '4px', boxSizing: 'border-box' }}
//                 />
//               </div>

//               <div style={{ display: 'flex', gap: '12px', marginTop: '1rem' }}>
//                 <button
//                   type="button"
//                   onClick={handleIssue}
//                   disabled={loading}
//                   style={{
//                     flex: 1,
//                     padding: '12px',
//                     backgroundColor: '#0056b3',
//                     color: '#fff',
//                     border: 'none',
//                     borderRadius: '4px',
//                     cursor: loading ? 'not-allowed' : 'pointer',
//                     fontWeight: 'bold'
//                   }}
//                 >
//                   {loading ? 'Processing...' : '1. Issue (Anchor Content Hash)'}
//                 </button>

//                 <button
//                   type="button"
//                   onClick={handleVerify}
//                   disabled={loading}
//                   style={{
//                     flex: 1,
//                     padding: '12px',
//                     backgroundColor: '#28a745',
//                     color: '#fff',
//                     border: 'none',
//                     borderRadius: '4px',
//                     cursor: loading ? 'not-allowed' : 'pointer',
//                     fontWeight: 'bold'
//                   }}
//                 >
//                   {loading ? 'Processing...' : '2. Verify Against Ledger'}
//                 </button>
//               </div>
//             </form>
//           </div>

//           {latencyData && (
//             <div style={{
//               marginTop: '1.5rem',
//               padding: '1rem',
//               backgroundColor: '#f8f9fa',
//               borderRadius: '6px',
//               border: '1px solid #e9ecef',
//               fontSize: '0.9rem'
//             }}>
//               <strong>Execution Latency Breakdown:</strong>
//               <div style={{ display: 'flex', gap: '15px', marginTop: '6px', flexWrap: 'wrap' }}>
//                 <span>Extraction: <strong>{latencyData.extractionMs?.toFixed(2)} ms</strong></span>
//                 <span>Canonicalization: <strong>{latencyData.canonicalizationMs?.toFixed(2)} ms</strong></span>
//                 <span>Ledger Interaction: <strong>{(latencyData.blockchainCommitMs || latencyData.gatewayRpcMs)?.toFixed(2)} ms</strong></span>
//                 <span>Total: <strong>{latencyData.totalMs?.toFixed(2)} ms</strong></span>
//               </div>
//             </div>
//           )}

//           {result && (
//             <div style={{
//               marginTop: '1.5rem',
//               padding: '1.2rem',
//               borderRadius: '6px',
//               backgroundColor: (result.isRevoked || result.certificate?.isRevoked) ? '#fff3cd' : '#e8f4f8',
//               borderLeft: `6px solid ${(result.isRevoked || result.certificate?.isRevoked) ? '#dc3545' : '#28a745'}`
//             }}>
//               <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
//                 <h3 style={{ margin: 0, color: (result.isRevoked || result.certificate?.isRevoked) ? '#721c24' : '#28a745' }}>
//                   {(result.isRevoked || result.certificate?.isRevoked) ? '⚠️ RECORD LOCATED (REVOKED)' : '✅ GENUINE & UNTAMPERED DOCUMENT'}
//                 </h3>

//                 {!(result.isRevoked || result.certificate?.isRevoked) && (
//                   <button
//                     type="button"
//                     onClick={handleRevoke}
//                     disabled={revokeLoading}
//                     style={{
//                       padding: '6px 14px',
//                       backgroundColor: '#dc3545',
//                       color: '#fff',
//                       border: 'none',
//                       borderRadius: '4px',
//                       cursor: revokeLoading ? 'not-allowed' : 'pointer',
//                       fontWeight: 'bold',
//                       fontSize: '0.85rem'
//                     }}
//                   >
//                     {revokeLoading ? 'Submitting Revocation...' : '🚫 Revoke Certificate'}
//                   </button>
//                 )}
//               </div>

//               <div style={{ marginTop: '10px' }}>
//                 <p><strong>SHA-256 Textual Hash:</strong> <code style={{ wordBreak: 'break-all' }}>{result.certHash}</code></p>
//                 <p><strong>Certificate ID:</strong> {result.certificate?.certId || certId}</p>
//                 <p><strong>Document Type:</strong> {result.certificate?.docType || docType}</p>
//                 <p><strong>Issuing Authority:</strong> {result.certificate?.issuer || 'Pareeksha Bhavan'}</p>
//                 {(result.isRevoked || result.certificate?.isRevoked) && (
//                   <p style={{ color: '#dc3545' }}>
//                     <strong>Revocation Reason:</strong> {result.certificate?.revokeReason || 'Revoked by authority'}
//                   </p>
//                 )}
//               </div>

//               <div style={{ marginTop: '1.2rem' }}>
//                 <button
//                   type="button"
//                   onClick={handleFetchHistory}
//                   disabled={historyLoading}
//                   style={{
//                     padding: '10px 18px',
//                     backgroundColor: '#17a2b8',
//                     color: '#fff',
//                     border: 'none',
//                     borderRadius: '4px',
//                     cursor: historyLoading ? 'not-allowed' : 'pointer',
//                     fontWeight: 'bold'
//                   }}
//                 >
//                   {historyLoading ? 'Querying Blocks...' : '📜 View Immutable Audit Trail Timeline'}
//                 </button>
//               </div>

//               {historyTrail && (
//                 <div style={{ marginTop: '1.5rem', borderTop: '1px solid #ced4da', paddingTop: '1rem' }}>
//                   <h4 style={{ margin: '0 0 1rem 0', color: '#114b5f' }}>
//                     Immutable Ledger Provenance ({historyTrail.length} Event{historyTrail.length !== 1 ? 's' : ''})
//                   </h4>
//                   <div style={{ position: 'relative', paddingLeft: '24px', borderLeft: '3px solid #17a2b8' }}>
//                     {historyTrail.map((entry, idx) => {
//                       const isRevokeEvent = entry.record?.isRevoked || entry.isDelete;
//                       return (
//                         <div key={entry.txId || idx} style={{ marginBottom: '1.5rem', position: 'relative' }}>
//                           <div style={{
//                             position: 'absolute',
//                             left: '-31px',
//                             top: '0px',
//                             width: '12px',
//                             height: '12px',
//                             borderRadius: '50%',
//                             backgroundColor: isRevokeEvent ? '#dc3545' : '#17a2b8',
//                             border: '2px solid #fff'
//                           }} />
//                           <div style={{ background: '#fff', padding: '10px 14px', borderRadius: '4px', border: '1px solid #dee2e6' }}>
//                             <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px', flexWrap: 'wrap' }}>
//                               <span style={{ fontWeight: 'bold', color: isRevokeEvent ? '#dc3545' : '#28a745' }}>
//                                 {isRevokeEvent ? 'REVOCATION COMMIT' : (idx === 0 ? 'ORIGIN COMMIT (ISSUANCE)' : 'STATE UPDATE')}
//                               </span>
//                               <span style={{ fontSize: '0.85rem', color: '#6c757d' }}>{entry.timestamp}</span>
//                             </div>
//                             <div style={{ fontSize: '0.82rem', wordBreak: 'break-all', color: '#495057' }}>
//                               <strong>Transaction ID:</strong> <code>{entry.txId}</code>
//                             </div>
//                             {entry.record && (
//                               <div style={{ marginTop: '6px', fontSize: '0.82rem', color: '#333' }}>
//                                 <span>Status: <strong>{entry.record.isRevoked ? 'Revoked' : 'Active'}</strong></span>
//                                 {entry.record.revokeReason && entry.record.revokeReason !== 'NONE' && (
//                                   <span> | Reason: <em>"{entry.record.revokeReason}"</em></span>
//                                 )}
//                               </div>
//                             )}
//                           </div>
//                         </div>
//                       );
//                     })}
//                   </div>
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       )}

//       {/* ============================================================= */}
//       {/* VIEW 2: ASYNC BULK INGESTION (REDIS + BULLMQ)                 */}
//       {/* ============================================================= */}
//       {activeTab === 'bulk' && (
//         <div style={{ border: '1px solid #cfd8dc', borderRadius: '8px', padding: '1.5rem', background: '#f8fafc' }}>
//           <h2 style={{ color: '#0d47a1', marginTop: 0 }}>Institutional Bulk Certificate Issuance</h2>
//           <p style={{ color: '#546e7a', fontSize: '0.9rem', lineHeight: '1.5' }}>
//             Upload a compressed ZIP archive containing PDF credentials and a <code>manifest.json</code> descriptor.
//             Jobs are enqueued to a Redis message queue and processed asynchronously by background workers in 200-transaction chunks.
//           </p>

//           <form onSubmit={handleBulkUpload} style={{ marginTop: '1.2rem' }}>
//             <div style={{
//               padding: '20px',
//               border: '2px dashed #90a4ae',
//               borderRadius: '8px',
//               backgroundColor: '#eceff1',
//               textAlign: 'center',
//               marginBottom: '1rem'
//             }}>
//               <input
//                 type="file"
//                 accept=".zip"
//                 id="zipFileInput"
//                 onChange={e => {
//                   if (e.target.files && e.target.files[0]) {
//                     setZipFile(e.target.files[0]);
//                     setBulkResult(null);
//                     setBulkError(null);
//                     setJobId(null);
//                     setJobProgress(0);
//                   }
//                 }}
//                 style={{ display: 'none' }}
//               />
//               <label htmlFor="zipFileInput" style={{ cursor: 'pointer', fontWeight: 'bold', color: '#37474f' }}>
//                 {zipFile
//                   ? `📦 Selected Archive: ${zipFile.name} (${(zipFile.size / (1024 * 1024)).toFixed(2)} MB)`
//                   : '📁 Click to Choose cohort batch ZIP'}
//               </label>
//             </div>

//             <button
//               type="submit"
//               disabled={!zipFile || bulkLoading}
//               style={{
//                 width: '100%',
//                 padding: '12px',
//                 backgroundColor: bulkLoading ? '#607d8b' : '#1976d2',
//                 color: '#fff',
//                 border: 'none',
//                 borderRadius: '4px',
//                 fontSize: '1rem',
//                 fontWeight: 'bold',
//                 cursor: (!zipFile || bulkLoading) ? 'not-allowed' : 'pointer'
//               }}
//             >
//               {bulkLoading ? `Processing Batch in Background (${jobProgress}%)...` : 'Dispatch Batch to Redis Queue'}
//             </button>
//           </form>

//           {/* Active Job Progress Dashboard */}
//           {bulkLoading && (
//             <div style={{
//               marginTop: '1.5rem',
//               padding: '1.2rem',
//               background: '#fff',
//               border: '1px solid #bbdefb',
//               borderRadius: '6px'
//             }}>
//               <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
//                 <span style={{ fontWeight: 'bold', color: '#0d47a1' }}>
//                   Job ID: <code>{jobId || 'Allocating...'}</code>
//                 </span>
//                 <span style={{ fontWeight: 'bold', color: '#1565c0' }}>
//                   Status: {jobState} ({jobProgress}%)
//                 </span>
//               </div>

//               {/* Animated Progress Bar */}
//               <div style={{ background: '#e0e0e0', borderRadius: '4px', height: '16px', overflow: 'hidden' }}>
//                 <div style={{
//                   width: `${jobProgress}%`,
//                   background: jobProgress < 50 ? '#0288d1' : '#2e7d32',
//                   height: '100%',
//                   transition: 'width 0.4s ease'
//                 }} />
//               </div>

//               <div style={{ fontSize: '0.8rem', color: '#607d8b', marginTop: '6px' }}>
//                 {jobProgress < 50
//                   ? 'Phase 1: PDF Stream Extraction, Normalization & RFC 8785 Canonical Hashing...'
//                   : 'Phase 2: Committing 200-certificate transaction chunks to Hyperledger Fabric peers...'}
//               </div>
//             </div>
//           )}

//           {bulkError && (
//             <div style={{ marginTop: '1.2rem', padding: '12px', backgroundColor: '#ffebee', border: '1px solid #ef5350', borderRadius: '4px', color: '#c62828' }}>
//               <strong>Error:</strong> {bulkError}
//             </div>
//           )}

//           {/* Completed Job Results & Metrics */}
//           {bulkResult && (
//             <div style={{ marginTop: '1.5rem' }}>
//               <div style={{
//                 display: 'flex',
//                 gap: '20px',
//                 padding: '14px',
//                 background: '#e8f5e9',
//                 border: '1px solid #a5d6a7',
//                 borderRadius: '6px',
//                 fontSize: '0.95rem'
//               }}>
//                 <div><strong>Committed:</strong> <span style={{ color: '#2e7d32', fontWeight: 'bold' }}>{bulkResult.totalCommitted}</span></div>
//                 <div><strong>Skipped/Duplicates:</strong> <span style={{ color: '#d32f2f', fontWeight: 'bold' }}>{bulkResult.totalSkipped || 0}</span></div>
//                 <div><strong>Queue Status:</strong> <span style={{ color: '#1565c0', fontWeight: 'bold' }}>COMPLETED</span></div>
//               </div>

//               {/* Execution Latency Breakdown Card */}
//               {bulkResult.timing && (
//                 <div style={{
//                   marginTop: '1.2rem',
//                   padding: '1.2rem',
//                   backgroundColor: '#ffffff',
//                   borderRadius: '6px',
//                   border: '1px solid #cfd8dc',
//                   boxShadow: '0 2px 4px rgba(0,0,0,0.03)'
//                 }}>
//                   <h4 style={{ margin: '0 0 0.75rem 0', color: '#263238', fontSize: '0.95rem' }}>
//                     ⚡ Worker Execution & Raft Consensus Metrics
//                   </h4>
//                   <div style={{
//                     display: 'grid',
//                     gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
//                     gap: '12px',
//                     textAlign: 'center'
//                   }}>
//                     <div style={{ background: '#f1f5f9', padding: '10px', borderRadius: '6px', border: '1px solid #e2e8f0' }}>
//                       <div style={{ fontSize: '0.78rem', color: '#64748b', fontWeight: '600', textTransform: 'uppercase' }}>
//                         Stream Parsing & Hashing
//                       </div>
//                       <div style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#0369a1', marginTop: '4px' }}>
//                         {bulkResult.timing.parsingTimeSeconds}s
//                       </div>
//                     </div>

//                     <div style={{ background: '#f1f5f9', padding: '10px', borderRadius: '6px', border: '1px solid #e2e8f0' }}>
//                       <div style={{ fontSize: '0.78rem', color: '#64748b', fontWeight: '600', textTransform: 'uppercase' }}>
//                         Fabric Raft Commits (Chunks)
//                       </div>
//                       <div style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#0369a1', marginTop: '4px' }}>
//                         {bulkResult.timing.fabricCommitTimeSeconds}s
//                       </div>
//                     </div>

//                     <div style={{ background: '#ecfdf5', padding: '10px', borderRadius: '6px', border: '1px solid #a7f3d0' }}>
//                       <div style={{ fontSize: '0.78rem', color: '#047857', fontWeight: '600', textTransform: 'uppercase' }}>
//                         Total Pipeline Duration
//                       </div>
//                       <div style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#065f46', marginTop: '4px' }}>
//                         {bulkResult.timing.totalTimeSeconds}s
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               <h4 style={{ marginTop: '1.5rem', marginBottom: '0.5rem', color: '#1a237e' }}>
//                 Ledger State Commits ({bulkResult.issuedRecords?.length || 0} Records)
//               </h4>
//               <p style={{ fontSize: '0.85rem', color: '#666', marginTop: 0 }}>
//                 Click <strong>"Verify Record"</strong> on any row to instantly redirect to the Single Inspection tab and query the peer's World State.
//               </p>

//               <div style={{ maxHeight: '350px', overflowY: 'auto', border: '1px solid #e0e0e0', borderRadius: '4px' }}>
//                 <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '0.85rem' }}>
//                   <thead style={{ background: '#eceff1', position: 'sticky', top: 0 }}>
//                     <tr>
//                       {/* <th style={{ padding: '8px 12px', borderBottom: '2px solid #cfd8dc' }}>#</th> */}
//                       {/* <th style={{ padding: '8px 12px', borderBottom: '2px solid #cfd8dc' }}>Certificate ID</th>
//                       <th style={{ padding: '8px 12px', borderBottom: '2px solid #cfd8dc' }}>Deterministic SHA-256 Hash</th>
//                       <th style={{ padding: '8px 12px', borderBottom: '2px solid #cfd8dc' }}>Action</th> */}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {/* Completed Job Results & Metrics */}
//                     {bulkResult && (
//                       <div style={{ marginTop: '1.5rem' }}>
//                         {/* Summary Metric Header */}
//                         <div style={{
//                           display: 'flex',
//                           gap: '20px',
//                           padding: '14px',
//                           background: '#e8f5e9',
//                           border: '1px solid #a5d6a7',
//                           borderRadius: '6px',
//                           fontSize: '0.95rem'
//                         }}>
//                           <div><strong>Committed:</strong> <span style={{ color: '#2e7d32', fontWeight: 'bold' }}>{bulkResult.totalCommitted}</span></div>
//                           <div><strong>Skipped/Duplicates:</strong> <span style={{ color: '#d32f2f', fontWeight: 'bold' }}>{bulkResult.totalSkipped || 0}</span></div>
//                           <div><strong>Queue Status:</strong> <span style={{ color: '#1565c0', fontWeight: 'bold' }}>COMPLETED</span></div>
//                         </div>

//                         {/* Skipped / Duplicate Records Warning Table */}
//                         {bulkResult.skippedRecords && bulkResult.skippedRecords.length > 0 && (
//                           <div style={{
//                             marginTop: '1.2rem',
//                             padding: '1rem',
//                             backgroundColor: '#fff8e1',
//                             border: '1px solid #ffe082',
//                             borderRadius: '6px'
//                           }}>
//                             <h4 style={{ margin: '0 0 0.5rem 0', color: '#b78103', fontSize: '0.95rem' }}>
//                               ⚠️ Skipped Records ({bulkResult.skippedRecords.length})
//                             </h4>
//                             <p style={{ fontSize: '0.85rem', color: '#6d4c41', marginTop: 0 }}>
//                               These records were skipped because of missing attributes, missing PDFs, or duplicate registration on the ledger.
//                             </p>

//                             <div style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #ffe082', borderRadius: '4px', background: '#fff' }}>
//                               <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '0.82rem' }}>
//                                 <thead style={{ background: '#fff3e0', position: 'sticky', top: 0 }}>
//                                   <tr>
//                                     <th style={{ padding: '6px 10px', borderBottom: '1px solid #ffe082' }}>#</th>
//                                     <th style={{ padding: '6px 10px', borderBottom: '1px solid #ffe082' }}>Cert ID / Filename</th>
//                                     <th style={{ padding: '6px 10px', borderBottom: '1px solid #ffe082' }}>Reason</th>
//                                   </tr>
//                                 </thead>
//                                 <tbody>
//                                   {bulkResult.skippedRecords.map((item, idx) => (
//                                     <tr key={idx} style={{ background: idx % 2 === 0 ? '#fff' : '#fffde7' }}>
//                                       <td style={{ padding: '6px 10px', borderBottom: '1px solid #eee' }}>{idx + 1}</td>
//                                       <td style={{ padding: '6px 10px', borderBottom: '1px solid #eee', fontWeight: 'bold' }}>
//                                         {item.certId || item.filename || 'N/A'}
//                                       </td>
//                                       <td style={{ padding: '6px 10px', borderBottom: '1px solid #eee', color: '#c62828' }}>
//                                         {item.reason}
//                                       </td>
//                                     </tr>
//                                   ))}
//                                 </tbody>
//                               </table>
//                             </div>
//                           </div>
//                         )}

//                         {/* Execution Latency Breakdown Card */}
//                         {bulkResult.timing && (
//                           <div style={{
//                             marginTop: '1.2rem',
//                             padding: '1.2rem',
//                             backgroundColor: '#ffffff',
//                             borderRadius: '6px',
//                             border: '1px solid #cfd8dc',
//                             boxShadow: '0 2px 4px rgba(0,0,0,0.03)'
//                           }}>
//                             <h4 style={{ margin: '0 0 0.75rem 0', color: '#263238', fontSize: '0.95rem' }}>
//                               ⚡ Worker Execution & Raft Consensus Metrics
//                             </h4>
//                             <div style={{
//                               display: 'grid',
//                               gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
//                               gap: '12px',
//                               textAlign: 'center'
//                             }}>
//                               <div style={{ background: '#f1f5f9', padding: '10px', borderRadius: '6px', border: '1px solid #e2e8f0' }}>
//                                 <div style={{ fontSize: '0.78rem', color: '#64748b', fontWeight: '600', textTransform: 'uppercase' }}>
//                                   Stream Parsing & Hashing
//                                 </div>
//                                 <div style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#0369a1', marginTop: '4px' }}>
//                                   {bulkResult.timing.parsingTimeSeconds}s
//                                 </div>
//                               </div>

//                               <div style={{ background: '#f1f5f9', padding: '10px', borderRadius: '6px', border: '1px solid #e2e8f0' }}>
//                                 <div style={{ fontSize: '0.78rem', color: '#64748b', fontWeight: '600', textTransform: 'uppercase' }}>
//                                   Fabric Raft Commits (Chunks)
//                                 </div>
//                                 <div style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#0369a1', marginTop: '4px' }}>
//                                   {bulkResult.timing.fabricCommitTimeSeconds}s
//                                 </div>
//                               </div>

//                               <div style={{ background: '#ecfdf5', padding: '10px', borderRadius: '6px', border: '1px solid #a7f3d0' }}>
//                                 <div style={{ fontSize: '0.78rem', color: '#047857', fontWeight: '600', textTransform: 'uppercase' }}>
//                                   Total Pipeline Duration
//                                 </div>
//                                 <div style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#065f46', marginTop: '4px' }}>
//                                   {bulkResult.timing.totalTimeSeconds}s
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         )}

//                         {/* Ledger State Commits Table */}
//                         <h4 style={{ marginTop: '1.5rem', marginBottom: '0.5rem', color: '#1a237e' }}>
//                           Ledger State Commits ({bulkResult.issuedRecords?.length || 0} Records)
//                         </h4>
//                         <p style={{ fontSize: '0.85rem', color: '#666', marginTop: 0 }}>
//                           Click <strong>"Verify Record"</strong> on any row to redirect to the Single Inspection tab and query the peer's World State.
//                         </p>

//                         <div style={{ maxHeight: '350px', overflowY: 'auto', border: '1px solid #e0e0e0', borderRadius: '4px' }}>
//                           <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '0.85rem' }}>
//                             <thead style={{ background: '#eceff1', position: 'sticky', top: 0 }}>
//                               <tr>
//                                 <th style={{ padding: '8px 12px', borderBottom: '2px solid #cfd8dc' }}>#</th>
//                                 <th style={{ padding: '8px 12px', borderBottom: '2px solid #cfd8dc' }}>Certificate ID</th>
//                                 <th style={{ padding: '8px 12px', borderBottom: '2px solid #cfd8dc' }}>Deterministic SHA-256 Hash</th>
//                                 <th style={{ padding: '8px 12px', borderBottom: '2px solid #cfd8dc' }}>Action</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {bulkResult.issuedRecords?.map((rec, idx) => (
//                                 <tr key={rec.certHash || idx} style={{ background: idx % 2 === 0 ? '#fff' : '#f8f9fa' }}>
//                                   <td style={{ padding: '8px 12px', borderBottom: '1px solid #eee' }}>{idx + 1}</td>
//                                   <td style={{ padding: '8px 12px', borderBottom: '1px solid #eee', fontWeight: 'bold' }}>{rec.certId}</td>
//                                   <td style={{ padding: '8px 12px', borderBottom: '1px solid #eee', fontFamily: 'monospace', color: '#37474f' }}>
//                                     {rec.certHash.substring(0, 24)}...
//                                   </td>
//                                   <td style={{ padding: '8px 12px', borderBottom: '1px solid #eee' }}>
//                                     <button
//                                       type="button"
//                                       onClick={() => handleInspectBatchHash(rec.certHash)}
//                                       style={{
//                                         padding: '4px 8px',
//                                         backgroundColor: '#28a745',
//                                         color: '#fff',
//                                         border: 'none',
//                                         borderRadius: '3px',
//                                         cursor: 'pointer',
//                                         fontSize: '0.75rem',
//                                         fontWeight: 'bold'
//                                       }}
//                                     >
//                                       Verify Record
//                                     </button>
//                                   </td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                         </div>
//                       </div>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// }

// export default App;




import React, { useState, useCallback } from 'react';
import Header from './components/Header';
import NavigationTabs from './components/NavigationTabs';
import SingleCertView from './features/singleCert/SingleCertView';
import BulkBatchView from './features/bulkBatch/BulkBatchView';

export default function App() {
  const [activeTab, setActiveTab] = useState('single');
  const [activeUser, setActiveUser] = useState('officer1');
  const [inspectedHash, setInspectedHash] = useState(null);

  const handleInspectBatchHash = (certHash) => {
    setInspectedHash(certHash);
    setActiveTab('single');
  };

  // Stable callback reference
  const handleClearInspection = useCallback(() => {
    setInspectedHash(null);
  }, []);

  return (
    <div style={{ padding: '2rem', fontFamily: 'Segoe UI, sans-serif', maxWidth: '880px', margin: 'auto' }}>
      <Header activeUser={activeUser} onUserChange={setActiveUser} />
      <NavigationTabs activeTab={activeTab} onTabChange={setActiveTab} />

      {/* Preserve Single Cert State */}
      <div style={{ display: activeTab === 'single' ? 'block' : 'none' }}>
        <SingleCertView
          activeUser={activeUser}
          inspectedHash={inspectedHash}
          onClearInspection={handleClearInspection}
        />
      </div>

      {/* Preserve Bulk Batch State & Polling */}
      <div style={{ display: activeTab === 'bulk' ? 'block' : 'none' }}>
        <BulkBatchView
          activeUser={activeUser}
          onInspectHash={handleInspectBatchHash}
        />
      </div>
    </div>
  );
}